// extracted by mini-css-extract-plugin
module.exports = {"fontStyle":"Snackbar_fontStyle__4Uqwh"};